export default __webpack_public_path__ + "media/zurb/img/lab/playground/playground-codepen-288fdfec8a48d82ed4ad300f1cee671f.png";